import React from 'react';
import styled from 'styled-components';

type ImageComponentProps = {
  src: string
  alt?: string
  mb?: string
  mr?: string
  width?: string
  height?: string
  loading?: 'lazy' | 'eager'
}

const ImageStyle = styled.img<{$mr?: string, $mb?: string}>`
  border-radius: 4px;
  object-fit: cover;
  margin-right: ${props => props.$mr || '0'};
  margin-bottom: ${props => props.$mb || '0'};
`;

const Image: React.FC<ImageComponentProps> = ({ src, alt, mr, mb, width, height, loading }) => {
  return (
    <ImageStyle src={src} alt={alt} $mr={mr} $mb={mb} width={width || '250px'} height={height || '140px'} loading={loading} />
  );
};

export default Image;
